<template>
  <div />
</template>
<script>
export default {
    name: "DropdownLoader",
    mounted ()
    {
        const maxDropdown = $(".max_dropdown")

        maxDropdown.on("click", function ()
        {
            const thisDropdown = $(this)

            thisDropdown.toggleClass("active")

            const dropdown = thisDropdown.find(".box_dropdown")
            const boxDropdowns = $(".box_dropdown")

            boxDropdowns.not(dropdown).hide()
            boxDropdowns.not(dropdown).parent().removeClass("active")
            boxDropdowns.not(dropdown).parent().removeClass("reverse")

            dropdown.toggle(0)

            const topbarHeight = $(".top-bar").height()
            const relativeOffset = dropdown.offset().top - $(window).scrollTop() - topbarHeight
            const windowHeight = $(window).height()

            if ((relativeOffset > (windowHeight - topbarHeight) / 2) && (windowHeight - relativeOffset - topbarHeight < dropdown.height()))
            {
                thisDropdown.addClass("reverse")
            }
            else
            {
                thisDropdown.removeClass("reverse")
            }
        })
        maxDropdown.on("focusout", function ()
        {
            const thisDropdown = $(this)

            thisDropdown.removeClass("active")
            thisDropdown.removeClass("reverse")
            thisDropdown.find(".box_dropdown").hide()
        })
        $(".max_dropdown .box_dropdown li").on("click", function ()
        {
            $(this).parents(".max_dropdown").find("p").text($(this).find("b").text())
        })
        $(document).on("click", function (event)
        {
            if (!$(event.target).closest(".max_dropdown").length)
            {
                const thisDropdown = $(".box_dropdown")

                thisDropdown.parent().removeClass("active")
                thisDropdown.parent().removeClass("reverse")
                thisDropdown.hide()
            }
        })
    }
}
</script>
